import { BiUser, BiPhone, BiEnvelope, BiCheckCircle } from "react-icons/bi";
import { Image } from "@heroui/react";
import { Button } from "@heroui/react";
import { Link } from "@remix-run/react";
import WorkInProgressImg from "app/assets/Work-in-progress.png";
import { MetaFunction } from "@remix-run/node";
import { SEOHandle } from "@nasa-gcn/remix-seo";
import { getSocialMetaTags } from "app/utils/meta";

export const meta: MetaFunction = () =>
  getSocialMetaTags({
    title: "NSM | Promotional Products Now",
    description: "Message from the National Sales Manager at Promotional Products Now.",
    url: "https://www.promotionalproductsnow.au/national-sales-manager",

    extra: [
      {
        tagName: "link",
        rel: "canonical",
        href: "https://www.promotionalproductsnow.au/national-sales-manager",
      },
    ],
  });

const Message = () => {
  return (
    <div className="min-h-screen">
      <div className="overflow-hidden" itemScope itemType="https://schema.org/Person">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          {/* Content Section */}
          <div className="px-4 lg:px-8   flex-col justify-center">
            <div className="space-y-8">
              {/* Header */}
              <div className="space-y-4">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-12 h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full"></div>
                  <span className="text-sm font-semibold text-yellow-600 uppercase tracking-wider">
                    Leadership
                  </span>
                </div>

                <h1
                  className="text-4xl md:text-5xl xl:text-6xl font-bold text-gray-900 dark:text-white leading-tight"
                  itemProp="jobTitle"
                >
                  Message from{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-700">
                    National Sales Manager
                  </span>
                </h1>
              </div>

              {/* Content */}
              <div className="space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
                <p className="text-lg" itemProp="description">
                  There are many Promotional Product companies available to choose from and we
                  recognise the need to differentiate ourselves from our competitors to all current
                  and prospective customers.
                </p>

                <p className="text-lg" itemProp="description">
                  A few years ago, I worked for a Corporation and on numerous occasions I needed to
                  purchase large volumes of promotional products & items. Unfortunately, my
                  experiences led to much frustration with the promotional products industry.
                </p>

                <p className="text-lg" itemProp="description">
                  I have learnt from this experience and have implemented numerous customer-focused
                  policies and procedures. Additionally, my passion for customer service has
                  resulted in the implementation of Customer Satisfaction Surveys to ensure we
                  continue to track feedback, analyse results, and exceed best practice in all areas
                  of operation.
                </p>

                <p className="text-lg" itemProp="description">
                  I hope you will agree the results of our Customer Satisfaction Surveys show how
                  focused we are in meeting our goal to exceed customer expectations.
                </p>

                <p className="text-lg" itemProp="description">
                  If you are looking for a progressive company to provide you with the latest
                  promotional merchandise solutions, then I invite you to Contact Us. If you wish, I
                  am only too happy to discuss with you directly, the best promotional product
                  solutions for your specific needs and budget.
                </p>
              </div>

              {/* Key Highlights */}
              <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20 rounded-xl p-6">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                  Our Commitment to Excellence
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center space-x-3">
                    <BiCheckCircle className="text-yellow-600 text-xl flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">
                      Customer Satisfaction Surveys
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <BiCheckCircle className="text-yellow-600 text-xl flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">
                      Proven Cost-Saving Strategies
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <BiCheckCircle className="text-yellow-600 text-xl flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">
                      20+ Years of Experience
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <BiCheckCircle className="text-yellow-600 text-xl flex-shrink-0" />
                    <span className="text-gray-700 dark:text-gray-300">
                      5 Rock Solid Guarantees
                    </span>
                  </div>
                </div>
              </div>

              {/* Call to Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button
                  as={Link}
                  to="/contact"
                  size="lg"
                  className="bg-yellow-600 hover:bg-yellow-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-200 transform hover:scale-105"
                  startContent={<BiPhone className="text-lg" />}
                >
                  Contact Us
                </Button>
                <Button
                  as={Link}
                  to="/guarantees"
                  size="lg"
                  variant="bordered"
                  className="border-yellow-600 text-yellow-600 hover:bg-yellow-50 dark:hover:bg-yellow-900/20 font-semibold px-8 py-3 rounded-lg transition-all duration-200"
                >
                  View Our Guarantees
                </Button>
              </div>

              {/* Author Section */}
              <div className="pt-8 border-t border-gray-200 dark:border-gray-700">
                <div
                  className="flex items-center space-x-4 p-6 bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-900/20 dark:to-yellow-800/20 rounded-xl"
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
                      <BiUser size={28} className="text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white" itemProp="name">
                      Lynda Purchase
                    </h3>
                    <p
                      className="text-yellow-600 dark:text-yellow-400 font-semibold"
                      itemProp="jobTitle"
                    >
                      National Sales Manager
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Promotional Products Now
                    </p>
                    <div className="flex items-center space-x-4 mt-3">
                      <a
                        href="tel:+61 1300664999"
                        className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-yellow-600 transition-colors"
                      >
                        <BiPhone className="text-lg" />
                        <span>+61 1300664999</span>
                      </a>
                      <a
                        href="mailto:info@promotionalproductsnow.au"
                        className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-yellow-600 transition-colors"
                      >
                        <BiEnvelope className="text-lg" />
                        <span>Email Us</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative">
            <div className="relative h-full min-h-[200px] lg:min-h-screen">
              <Image
                shadow="none"
                radius="none"
                width="100%"
                alt="Work in progress"
                className="object-cover w-full h-full rounded-2xl"
                src={WorkInProgressImg}
                itemProp="image"
              />

              {/* Floating Stats Card */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const handle: SEOHandle = {
  getSitemapEntries: async () => [
    {
      route: "/national-sales-manager",
      priority: 0.6,
      lastmod: new Date().toISOString(),
      changefreq: "monthly",
    },
  ],
};

export default Message;
